import React, { useState } from 'react';
import { Loader } from 'lucide-react';

import { appPath } from '../routes/appPaths';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5050';

export default function PaymentTestScreen() {
  const [amount, setAmount] = useState('100');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handlePay() {
    setLoading(true);
    setError(null);
    try {
      const returnUrl = `${window.location.origin}${appPath('/payment-return')}`;
      const res = await fetch(`${API_URL}/orders/test-payment`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ amount: Number(amount), returnUrl }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.paymentUrl) {
        setError(data.message ?? data.raw?.Message ?? 'Не удалось создать платёж');
        return;
      }
      window.location.assign(data.paymentUrl);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Ошибка');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6" style={{ background: '#f4f4f4' }}>
      <div
        className="w-full max-w-sm rounded-3xl p-6 space-y-4"
        style={{
          background: 'rgba(255,255,255,0.92)',
          border: '1px solid rgba(0,0,0,0.05)',
          boxShadow: '0 3px 14px rgba(0,0,0,0.05)',
        }}
      >
        <h1 className="text-xl font-bold text-[#1a1a1a]">Тест оплаты T-Кассы</h1>
        <p className="text-xs text-black/40">Тестовая карта: 4300 0000 0000 0777 · 12/30 · 111</p>

        <div>
          <label className="text-xs font-semibold uppercase tracking-wider text-black/40 mb-2 block">
            Сумма, ₽
          </label>
          <input
            type="number"
            min="1"
            value={amount}
            onChange={e => setAmount(e.target.value)}
            className="w-full rounded-2xl px-4 py-3 text-sm font-medium outline-none"
            style={{ background: '#f4f4f4', border: '1px solid rgba(0,0,0,0.06)', color: '#1a1a1a' }}
          />
        </div>

        {error && (
          <p className="text-xs font-medium text-red-500">{error}</p>
        )}

        <button
          onClick={handlePay}
          disabled={loading || !amount || Number(amount) < 1}
          className="w-full py-4 rounded-2xl font-bold text-base text-white transition-all active:scale-95 disabled:opacity-50 flex items-center justify-center gap-2"
          style={{ background: '#0a0a0a', boxShadow: '0 6px 20px rgba(0,0,0,0.22)' }}
        >
          {loading && <Loader size={18} className="animate-spin" />}
          {loading ? 'Создаём платёж...' : `Оплатить ${amount} ₽`}
        </button>
      </div>
    </div>
  );
}
